// This React component, `ReportPage`, is a server-side rendered (SSR) component using Next.js.
// It fetches gender gap report data from the provided `dataSource` and passes it to the `Report` component for rendering.
//  The component ensures that the report data is properly structured before being displayed.
//  It follows the `TasticProps` type structure for better type safety and maintainability.

'use client';

import React from 'react';
import { TasticProps } from '../types';
import { ReportPageDataSource } from 'types/next';
import Report from 'components/commercetools-ui/organisms/landing-pages/gender-gap-report';

const ReportPage = ({ data }: TasticProps<ReportPageDataSource>) => {
  const genderGapData = data?.data?.dataSource;
  console.log('genderGapData', genderGapData);

  return (
    <>
      <Report reportData={genderGapData} />
    </>
  );
};

export default ReportPage;
